<template>
  <div></div>
</template>

<script>
export default {
  created: async function () {
    localStorage.removeItem(this.$apikeyname)
    this.$store.apidata = {}
    window.open("https://go.superiorpress.com/_hcms/mem/logout",'_blank');
    await new Promise(resolve => setTimeout(resolve, 2000))
    window.location.replace(`https://go.superiorpress.com/tac-login?url=${window.location.origin}`)
  },
};
</script>